import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { getCommonState } from "../redux/store/getState";
import moment from "moment";
import { CloseIcon } from "../assets";
import { Flex } from "antd";
import { setFilterValues } from "../redux/apiSlice/commonSlice";

export default function AppliedFilter() {
  const dispatch = useAppDispatch();
  const { filterFrom, filterTo } = useAppSelector(getCommonState);

  function clearFilter() {
    dispatch(setFilterValues({ filterFrom: 0, filterTo: 0 }));
  }

  if (filterFrom && filterTo)
    return (
      <div className="filter_pill" onClick={clearFilter}>
        <Flex align="center" justify="center">
          <small>
            {moment.unix(filterFrom).format("DD/MM/YYYY hh:mmA")} -{" "}
            {moment.unix(filterTo).format("DD/MM/YYYY hh:mmA")}
          </small>
          <CloseIcon />
        </Flex>
      </div>
    );
  return null;
}
